import * as React from 'react'
import Provider from '@theme/Provider'

import Component from './DrawerComponent'

import { createRoot, Root } from 'react-dom/client'

let container: HTMLElement | null
let root: Root | null
let active = false

const Drawer = {
  open: (props: DrawerProps) => {
    container = document.getElementById('portal_root')

    if (container) {
      root = createRoot(container)
      root.render(
        <Provider>
          <Component {...props} onClose={() => Drawer.close()} />
        </Provider>
      )
    }

    active = true
  },
  close: () => {
    if (root && active) {
      root.unmount()
      active = false
    }
  },
}

export default Drawer
